/* Georgious — cart colour change, for Slide Light only */
document.addEventListener('change', async function(event) {
  const select = event.target.closest('.georgious-cart-finish-select');
  if (!select) return;
  event.stopPropagation();
  event.stopImmediatePropagation();
  if (select.dataset.busy === 'true') return;
  const previous = [...select.options].find(option => option.defaultSelected);
  const status = select.parentElement.querySelector('.georgious-cart-finish-status');
  const newVariant = Number(select.value);
  const oldKey = select.dataset.lineKey;
  const qty = Number(select.dataset.quantity);
  if (!newVariant || !oldKey || !Number.isInteger(qty) || qty < 1 || String(newVariant) === oldKey.split(':')[0]) return;
  select.dataset.busy = 'true';
  select.disabled = true;
  status.textContent = 'Updating colour…';
  const root = window.Shopify?.routes?.root || '/';
  const call = async (endpoint, data) => {
    const response = await fetch(root + 'cart/' + endpoint + '.js', {
      method: 'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(data)
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400 || result.errors) throw new Error(result.description || result.message || 'Cart update failed');
    return result;
  };
  try {
    let properties = JSON.parse(select.dataset.properties || '{}');
    if (Array.isArray(properties)) properties = Object.fromEntries(properties);
    await call('add', {items:[{id:newVariant,quantity:qty,properties}]});
    await call('change', {id:oldKey,quantity:0});
    window.location.reload();
  } catch(error) {
    status.textContent = 'Could not change colour. Please refresh the cart and try again.';
    select.value = previous?.value || select.value;
    select.disabled = false;
    select.dataset.busy = 'false';
    console.error('Georgious colour change:', error);
  }
}, true);
